import axios from "axios";
import { convertObjectToUrlParams } from "../helpers/convertObjToUrlParams";

export interface AnnualCatchReport {
  organizationID?: number;
  beginDate?: string;
  endDate?: string;
  lakeID?: number;
  gearID?: number;
  gridID?: number;
  speciesID?: number;
  mgmtUnitID?: number;
}

export const getAnnualCatchReport = async (params: AnnualCatchReport) => {
  try {
    const response = await axios.get(
      `${
        process.env.REACT_APP_API
      }/Report/AnnualCatch${convertObjectToUrlParams(params)}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
